import { render, staticRenderFns } from "./clientes-detalhe.vue?vue&type=template&id=0c186222"
import script from "./clientes-detalhe.vue?vue&type=script&lang=js"
export * from "./clientes-detalhe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports